const CAR_URL = 'https://clipartart.com/images/car-clipart-gif-1.gif';
const HOUSE_URL =
	'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcT1-eVOj1Dn5pRt0TIszJDesn-Ijevbm_Cku1w4tZkvpln5ROD7';
const FIREWORKS_URL = 'https://acegif.com/wp-content/uploads/firework-1.gif';

export default {
	CAR_URL,
	HOUSE_URL,
	FIREWORKS_URL
};
